export default __webpack_public_path__ + "static/media/project4.6a16d4af.png";